import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import classNames from "classnames";
import Select from "react-select";

// UI Components
import BootstrapTable from "react-bootstrap-table-next"; // https://react-bootstrap-table.github.io/react-bootstrap-table2/storybook/index.html
import paginationFactory from "react-bootstrap-table2-paginator";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBell, faUserPlus } from "@fortawesome/free-solid-svg-icons";
import { toastr } from "react-redux-toastr";
import { Row, Col, Button, Container, Card, CardBody, CardHeader, Input } from "reactstrap";

import { client_config } from "../../../utils/clientConfigs";
// State
import {
  getSuppressionlist,
  selectSuppressionlist,
  createSuppressionlist,
  deleteSuppressionlist,
  clearSuppressionlist,
} from "../../../redux/actions/adminActions";

// Custom Components
import { Group } from "../../../utils/logger";
import Loader from "../../../components/Loader";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import Header from "./Header";
import suppressionlist_table_schema from "./suppressionlistTableSchema";
import SuppressionlistModal from "./Modal.SuppressionlistRecord";

// Globals
const RECORDS_PER_PAGE = "mbEonsRecordsPerPage";

const suppression_device_type_list = client_config.enabled_features.suppression_list || [];

const AddSuppressionlistRecord = ({ onUserAction }) => (
  <Row className={classNames("mb-4")}>
    <Col className="text-right">
      <Button color="primary" onClick={() => onUserAction("add")}>
        <FontAwesomeIcon icon={faUserPlus} className="mr-2" />
        Add Record to Suppression List
      </Button>
    </Col>
  </Row>
);

const CriteriaSection = ({
  loading,
  recordSearch,
  onSearchClick,
  deviceTypeOptions,
  onControlTextChange,
  onUserAction,
}) => (
  <Card>
    <CardHeader>
      <Row>
        <Col>
          <h4 className="text-muted">Provide Opt-out criteria:</h4>
        </Col>
      </Row>
    </CardHeader>
    <CardBody>
      <Row>
        <Col>
          <p>
            <b>Note:</b>
            <p>
              You can list Opt-outs by selecting Device Type, contact number and click Search
              button.
            </p>
            <p>
              Search performed is LIKE search, so contacts matching partially searched text will be
              listed.
            </p>
          </p>
        </Col>
      </Row>
      <Row>
        <Col md={3}>
          <p>
            <strong>Device Type:</strong>
          </p>
        </Col>

        <Col md={6}>
          <Select
            className="flex-fill mb-2 ml-2"
            value={
              deviceTypeOptions.includes(recordSearch.search_device_type)
                ? {
                    label: recordSearch.search_device_type,
                    value: recordSearch.search_device_type,
                  }
                : ""
            }
            options={deviceTypeOptions.map((type) => ({ label: type, value: type }))}
            onChange={({ value }) => onControlTextChange("search_device_type", { value })}
            placeholder={deviceTypeOptions.join(", ")}
          />
        </Col>
      </Row>
      <Row>
        <Col md={3}>
          <p>
            <strong>Contact Detail:</strong>
          </p>
        </Col>

        <Col md={6}>
          <Input
            className="mb-3 ml-2"
            placeholder={"email" === (recordSearch.search_device_type || "") ? "Email" : "Phone"}
            name="search_device_text"
            value={recordSearch.search_device_text || ""}
            onChange={(evt) => onControlTextChange("search_device_text", evt.target.value)}
          />
        </Col>
      </Row>
      <Row>
        <Col className="text-center">
          <Button color="primary pl-5 pr-5" onClick={(e) => onSearchClick(e)} disabled={loading}>
            Search
            {loading && <FontAwesomeIcon icon={faSpinner} className="ml-2" spin />}
          </Button>
        </Col>
      </Row>
    </CardBody>
  </Card>
);

class Suppressionlist extends Component {
  constructor(props) {
    super(props);
    localStorage.setItem(RECORDS_PER_PAGE, localStorage.getItem(RECORDS_PER_PAGE) || 20);
    const device_type =
      suppression_device_type_list && suppression_device_type_list.length > 0
        ? suppression_device_type_list[0]
        : "sms";
    this.state = {
      search_device_text: "",
      sortorder: 1,
      sortby: "to_vch",
      search_device_type: device_type,
      pageNo: 1,
      // Modal
      modal: {
        type: "add",
        isOpen: false,
      },
    };

    this.LoggerGroup = new Group("Suppressionlist", { disable: false });
    this.toggleModal = this.toggleModal.bind(this);
    this.onUserAction = this.onUserAction.bind(this);
    this.onControlTextChange = this.onControlTextChange.bind(this);
    this.onSearchClick = this.onSearchClick.bind(this);
    this.onPageSizeChange = this.onPageSizeChange.bind(this);
    this.onPageNumberChange = this.onPageNumberChange.bind(this);
    this.onSortClick = this.onSortClick.bind(this);
    this.fetchSuppressionListData = this.fetchSuppressionListData.bind(this);
    this.handleCreateSuppression = this.handleCreateSuppression.bind(this);
  }

  fetchSuppressionListData(specialCaseObj) {
    const sortorder =
      specialCaseObj && Object.keys(specialCaseObj).includes("sortorder")
        ? specialCaseObj.sortorder
        : this.state.sortorder;
    let sortby =
      specialCaseObj && Object.keys(specialCaseObj).includes("sortby")
        ? specialCaseObj.sortby
        : this.state.sortby;

    switch (sortby) {
      case "to_vch":
        sortby = this.state.search_device_type === "email" ? "email_vch" : "phone_vch";
        break;
      case "from_vch":
        switch (this.state.search_device_type) {
          case "sms":
            sortby = "shortcode_vch";
            break;
          case "voice":
            sortby = "caller_id_vch";
            break;
          default:
            sortby = "email_vch";
        }
    }
    this.props.getSuppressionlist(1, {
      search_device_type: this.state.search_device_type || "",
      search_device_text: this.state.search_device_text || "",
      page: (specialCaseObj && specialCaseObj.pageNo) || this.state.pageNo || 1,
      limit: localStorage.getItem(RECORDS_PER_PAGE),
      sortorder: sortorder === 1 ? "asc" : "desc",
      sortby: sortby,
    });
  }

  componentDidMount() {
    this.fetchSuppressionListData();
  }

  onControlTextChange(nameState, valueText) {
    this.LoggerGroup.emit(`Control text ${[nameState]} - [${valueText}]`);
    switch (nameState) {
      case "search_device_type":
        this.setState({ [nameState]: valueText.value });
        break;
      default:
        this.setState({ [nameState]: valueText });
    }
  }

  onSortClick(sortby) {
    const sortorder = sortby === this.state.sortby ? (this.state.sortorder == 1 ? 0 : 1) : 1;
    this.setState({ sortby, sortorder });
    this.fetchSuppressionListData({ sortorder, sortby });
  }

  onSearchTextChange({ target }) {
    this.LoggerGroup.emit("Searching value", target.name, target.value);

    this.setState({ search_text: target.value });
  }

  onPageSizeChange() {
    this.fetchSuppressionListData();
  }

  onPageNumberChange(pageNo) {
    this.setState({ pageNo });

    this.fetchSuppressionListData({ pageNo });
  }

  onSearchClick(e) {
    if (e) {
      e.stopPropagation();
      e.preventDefault();
    }

    if (
      !this.state.search_device_type ||
      !suppression_device_type_list.includes(this.state.search_device_type)
    ) {
      return toastr.error("Oops", "Please choose device type option");
    }

    this.setState({ pageNo: 1, sortorder: 1, sortby: "to_vch" });
    this.fetchSuppressionListData();

    return;
  }

  onUserAction(type, suppressionRecord) {
    this.LoggerGroup.emit("User Action triggered", { dir: suppressionRecord });

    switch (type) {
      case "add":
        this.LoggerGroup.emit(`  [i] Adding Record to suppressionlist`);
        //this.props.selectSuppressionlist({});
        this.toggleModal(true);
        break;

      case "delete":
        this.props.selectSuppressionlist(suppressionRecord);
        this.LoggerGroup.emit(`  [i] Deleting Record`);
        toastr.confirm(
          `Are you sure you want to remove ${suppressionRecord.device_type} entry of ${suppressionRecord.to_vch} from suppression list?`,
          {
            okText: "Delete Suppression",
            onCancel: () =>
              this.LoggerGroup.emit(
                `Cancelled delete Suppression enry [${suppressionRecord.recordid}]`
              ),
            onOk: () => this.props.deleteSuppressionlist(suppressionRecord),
          }
        );
        break;

      default:
        return this.LoggerGroup.emit({ error: `Invalid user action type[${type}]` });
    }

    this.LoggerGroup.end();
  }

  toggleModal(show) {
    const modal = { ...this.state.modal };
    modal.isOpen = typeof show === "boolean" ? show : !modal.isOpen;
    this.setState({ modal: { ...modal } });
  }

  handleCreateSuppression(suppressionlistRecord) {
    this.setState({ search_device_type: suppressionlistRecord.device_type_vch, pageNo: 1 });
    return this.props.createSuppressionlist(suppressionlistRecord);
  }
  render() {
    const { loading, suppressionlist, selected } = this.props;
    const { onUserAction, onSortClick } = this;
    const { modal } = this.state;

    if (loading) {
      return <Loader />;
    }
    const totalItems = Number(this.props.searchCount || 1);
    const pageSize = Number(localStorage.getItem(RECORDS_PER_PAGE) || 20);
    const currentPage = Number(this.state.pageNo || 1);
    const totalPages = Math.ceil(totalItems / pageSize); //in case of decimlas always rounded up by 1

    const preFillItemsCount = currentPage === 1 ? 0 : (currentPage - 1) * pageSize;
    const postFillItemsCount = currentPage < totalPages ? (totalPages - currentPage) * pageSize : 0;

    let filtered_suppressionlist = suppressionlist || [];

    if (preFillItemsCount > 0)
      filtered_suppressionlist = new Array(preFillItemsCount)
        .fill(0)
        .concat(filtered_suppressionlist);
    if (postFillItemsCount > 0)
      filtered_suppressionlist = filtered_suppressionlist.concat(
        new Array(postFillItemsCount).fill(0)
      );

    const NoRecordCard = () => {
      return <p>&nbsp;&nbsp;</p>;
    };

    return (
      <Container fluid className="p-0">
        <Header />
        <AddSuppressionlistRecord onUserAction={this.onUserAction} />

        <CriteriaSection
          loading={this.props.loading}
          onControlTextChange={this.onControlTextChange}
          onSearchClick={this.onSearchClick}
          deviceTypeOptions={suppression_device_type_list}
          recordSearch={{
            search_device_text: this.state.search_device_text,
            search_device_type: this.state.search_device_type,
          }}
          onUserAction={this.onUserAction}
        />
        {modal.isOpen && (
          <SuppressionlistModal
            {...modal}
            createAction={this.handleCreateSuppression}
            toggleModal={this.toggleModal}
          />
        )}

        <Card>
          <CardBody>
            <BootstrapTable
              bootstrap4
              classes="table-responsive-md"
              hover
              keyField="recordid"
              data={filtered_suppressionlist}
              columns={suppressionlist_table_schema({ onUserAction, onSortClick })}
              bordered={false}
              pagination={paginationFactory({
                remote: true,
                page: this.state.pageNo || 1,
                totalSize: this.props.searchCount || 1,
                sizePerPage: Number(localStorage.getItem(RECORDS_PER_PAGE) || 50),
                sizePerPageList: [5, 10, 25, 50, 75, 100],
                onSizePerPageChange: (sizePerPage) => {
                  localStorage.setItem(RECORDS_PER_PAGE, sizePerPage || 20);
                  this.onPageSizeChange();
                },
                onPageChange: (page, sizePerPage) => {
                  localStorage.setItem(RECORDS_PER_PAGE, sizePerPage);
                  this.onControlTextChange("pageNo", page);
                  this.onPageNumberChange(page);
                },
              })}
              defaultSorted={[
                {
                  dataField: "from",
                  order: "asc",
                },
              ]}
              noDataIndication={NoRecordCard}
            />
          </CardBody>
        </Card>
      </Container>
    );
  }
}

Suppressionlist.propTypes = {
  errors: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  suppressionlist: PropTypes.array.isRequired,
  selected: PropTypes.object.isRequired,

  // APIs
  getSuppressionlist: PropTypes.func.isRequired,
  selectSuppressionlist: PropTypes.func.isRequired,
  createSuppressionlist: PropTypes.func.isRequired,
  deleteSuppressionlist: PropTypes.func.isRequired,
  clearSuppressionlist: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  errors: state.admin.errors,
  loading: state.admin.loading.suppressionlist,
  suppressionlist: state.admin.suppressionlist,
  selected: state.admin.selectedSuppressionlist,
  searchsuppression: state.admin.searchsuppression || {},
  searchCount: state.admin.suppressionAllCount,
});

export default connect(mapStateToProps, {
  getSuppressionlist,
  createSuppressionlist,
  selectSuppressionlist,
  deleteSuppressionlist,
  clearSuppressionlist,
})(Suppressionlist);
